import { Component, OnInit,ViewChild } from '@angular/core';
import { DeviceService} from '../services/device.service';
import { UserService} from '../services/user.service';
import { DeviceTypeService} from '../services/device-type.service';
import { Message} from 'primeng/primeng';
import { ConfirmationService} from 'primeng/primeng';
import { SelectItem} from 'primeng/primeng';
import { DatePipe } from '@angular/common';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-device',
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.css'],
  providers: [ConfirmationService]
})
export class DeviceComponent implements OnInit {

  addDeleteDevice: boolean;
  msgs: Message[] = [];
  device: any;
  devices : any [];
  typesDevice:SelectItem[];
  icons:SelectItem[];
  displayAdd: boolean = false;
  displayEdit: boolean = false;
  displayUsers: boolean = false;
  status: SelectItem[];
  blockedDocument: boolean = false;
  blockSpace: RegExp = /[^\s]/;
  cols: any[];
  usersAvailables: any[];
  usersSelecteds : any[];
  statusFilter: SelectItem[];
  quantityDeviceEnabled: number;
  quantityDeviceDisabled: number;
  dayNames:String[];
  statusFilterDefault:String="H";
  @ViewChild("dt") private table: Table;

  constructor(private deviceService : DeviceService,private deviceTypeService : DeviceTypeService,private confirmationService: ConfirmationService, private userService:UserService,private datePipe: DatePipe) { }

  ngOnInit() {
    this.dayNames = ["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"];
    this.statusFilter = [
      {label: 'Todos', value: null },
      {label: 'Habilitado', value: 'H'},
      {label: 'Inhabilitado', value: 'I'}
    ];
    this.cols = [
      { field: 'idDevice', header: 'ID' },
      { field: 'name', header: 'NOMBRE' },
      { field: 'nameDeviceType', header: 'TIPO' },
      { field: 'registerTime', header: 'FECHA DE CREACIÓN' }
    ];
    this.init();
    this.status = [
      {label: 'Habilitado', value: 'H', icon: 'fa fa-check-square-o'},
      {label: 'Inhabilitado', value: 'I', icon: 'fa fa-square-o'}
    ];
    this.typesDevice = [];
    this.deviceTypeService.findAll().then(data => {
      let response: any = data;
      response.deviceTypes.forEach(item => {
        this.typesDevice.push({label: item.name, value: item.idType});
      });
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });
    this.icons = [];
    this.icons.push({label: "Auto", value: 1});
    this.icons.push({label: "Taxi", value: 2});
    this.icons.push({label: "Bus", value: 3});
    this.icons.push({label: "Camion", value: 4});
    this.icons.push({label: "Autobus", value: 5});
    this.icons.push({label: "Auto de lujo", value: 6});
    this.icons.push({label: "Auto dañado", value: 7});
    this.icons.push({label: "Barredora", value: 8});
    this.icons.push({label: "Motocicleta", value: 9});
    this.icons.push({label: "Bicicleta", value: 10});
    this.icons.push({label: "Ambulancia", value: 11});
    this.icons.push({label: "Tren", value: 12});
    this.icons.push({label: "Barco", value: 13});
    this.icons.push({label: "Avion", value: 14});
    this.icons.push({label: "Celular", value: 15});
    this.icons.push({label: "Vagoneta", value: 16});
    this.icons.push({label: "Camioneta", value: 17});
    this.icons.push({label: "Reparto", value: 18});
    this.icons.push({label: "Anciana", value: 19});
    this.icons.push({label: "Anciano", value: 20});
    this.icons.push({label: "Hombre", value: 21});
    this.icons.push({label: "Mujer", value: 22});
    this.icons.push({label: "Niño", value: 23});
    this.icons.push({label: "Motoniveladora", value: 24});
    this.icons.push({label: "Excavadora", value: 25});
    this.icons.push({label: "Volqueta", value: 26});
    this.icons.push({label: "Tractocamion", value: 27});
    this.icons.push({label: "Aplanadora", value: 28});
    this.icons.push({label: "Trailer", value: 29});
    this.icons.push({label: "Chata", value: 30});
    this.icons.push({label: "Tolva", value: 31});
    this.icons.push({label: "Tractor", value: 32});
    this.icons.push({label: "Avioneta", value: 33});
    this.icons.push({label: "Cosechadora", value: 34});
    this.icons.sort(this.compare);
  }

  compare(a,b){
    if (a.label < b.label)
    return -1;
    if (a.label > b.label)
    return 1;
    return 0;
  }

  init(){
    this.quantityDeviceEnabled = 0;
    this.quantityDeviceDisabled = 0;
    this.usersAvailables = [];
    this.usersSelecteds = [];
    this.addDeleteDevice = this.userService.userLoged.idProfile == 1 || this.userService.userLoged.idProfile == 5 || this.userService.userLoged.idProfile == 6;
    this.devices = [];
    if(this.userService.userLoged.idProfile == 1){
      this.blockedDocument = true;
      this.deviceService.findAll().then(data => {
        let response: any = data;
        response.devices.forEach(item => {
          if(item){
            if(item.status == 'H'){
              this.quantityDeviceEnabled = this.quantityDeviceEnabled + 1;
            }else if(item.status == 'I'){
              this.quantityDeviceDisabled = this.quantityDeviceDisabled + 1;
            }
            if(item.name == null){
              item.name = "Sin Nombre";
            }
            this.devices.push(item);
          }
        });
        this.blockedDocument = false;
        this.table.filter(this.statusFilterDefault, 'status', 'equals');
      }).catch(err =>{
        console.log(err);
        this.blockedDocument = false;
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      });
    }else{
      this.blockedDocument = true;
      this.deviceService.findByUser(this.userService.userLoged.idUser).then(data => {
        let response: any = data;
        response.devices.forEach(item => {
          if(item.status == 'H'){
            this.quantityDeviceEnabled = this.quantityDeviceEnabled + 1;
          }else if(item.status == 'I'){
            this.quantityDeviceDisabled = this.quantityDeviceDisabled + 1;
          }
          this.devices.push(item);
        });
        this.blockedDocument = false;
        this.table.filter(this.statusFilterDefault, 'status', 'equals');
      }).catch(err =>{
        this.blockedDocument = false;
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      });
    }
    this.device = {status:"H", drivingSchedules : []};
    this.displayAdd = false;
    this.displayEdit = false;
    this.displayUsers = false;
  }

  showAdd(){
    this.displayAdd = true;
    this.device.drivingSchedules = [];
    for (let i = 1; i <= 7 ; i++) {
      let startTime= new Date();
      startTime.setHours(0,0,0);
      let endTime = new Date();
      endTime.setHours(23,59,59);
      this.device.drivingSchedules.push({
        day:i,
        dayName:this.dayNames[i-1],
        startTimeInput:startTime,
        startTime:this.datePipe.transform(startTime,"HH:mm:ss"),
        endTimeInput:endTime,endTime:this.datePipe.transform(endTime,"HH:mm:ss")});
      }
    }

    showUsers(device:any){
      this.device = device;
      this.displayUsers = true;
      this.usersAvailables = [];
      this.usersAvailables.push(this.userService.userLoged);
      this.usersSelecteds = [];
      this.loadDrivingSchedule(device);

      this.userService.findUsersBranch(this.userService.userLoged.idUser).then(data => {
        let response: any = data;
        response.users.forEach(item => {
          this.usersAvailables.push(item);
        });
        device.users.forEach(item => {
          this.usersSelecteds.push(item);
          let indice = -1;
          let i = 0;
          this.usersAvailables.forEach(available => {
            if(item.idUser == available.idUser){
              indice = i;
            }
            i++;
          });
          if(indice> -1){
            this.usersAvailables.splice(indice,1);
          }
        });
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      });
    }

    loadDrivingSchedule(device :any){
      device.drivingSchedules.forEach(drivingSchedule =>{
        let startTimeArray = drivingSchedule.startTime.split(":");
        let endTimeArray = drivingSchedule.endTime.split(":");

        let startTime= new Date();
        startTime.setHours(startTimeArray[0],startTimeArray[1],startTimeArray[2]);
        let endTime = new Date();
        endTime.setHours(endTimeArray[0],endTimeArray[1],endTimeArray[2]);

        drivingSchedule.startTimeInput = startTime;
        drivingSchedule.endTimeInput = endTime;
      });
    }

    showEdit(device:any){
      this.device=device;
      this.loadDrivingSchedule(device);
      this.displayEdit = true;
    }

    hide(){
      this.device = {status:"H"};
      this.displayAdd = false;
      this.displayEdit = false;
      this.displayUsers = false;
    }

    add(){
      this.blockedDocument = true;
      this.device.drivingSchedules.forEach(drivingSchedule =>{
        drivingSchedule.startTime = this.datePipe.transform(drivingSchedule.startTimeInput,"HH:mm:ss");
        drivingSchedule.endTime = this.datePipe.transform(drivingSchedule.endTimeInput,"HH:mm:ss")
      });
      this.device.users = [{idUser:this.userService.userLoged.idUser}];

      this.deviceService.create(this.device).then(data =>{
        let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro insertado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blockedDocument = false;
      });
    }

    edit(){
      this.blockedDocument = true;
      this.device.drivingSchedules.forEach(drivingSchedule =>{
        drivingSchedule.startTime = this.datePipe.transform(drivingSchedule.startTimeInput,"HH:mm:ss");
        drivingSchedule.endTime = this.datePipe.transform(drivingSchedule.endTimeInput,"HH:mm:ss")
      });

      if(this.usersSelecteds != null || this.usersSelecteds.length > 0){
        this.device.users = [];
        this.usersSelecteds.forEach(item => {
          this.device.users.push(item);
        });
      }
      this.deviceService.edit(this.device).then(data =>{
        let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blockedDocument = false;
      });
    }

    del(id: String){
      this.confirmationService.confirm({
        message: 'Esta seguro de eliminar el registro seleccionado?',
        header: 'Confirmación',
        icon: 'fa fa-trash',
        accept: () => {
          this.blockedDocument = true;
          this.deviceService.remove(id).then(data =>{
            let response: any = data;
            if(response.status == 'OK'){
              this.init();
              this.msgs = [{severity:'info', summary:'INFO', detail:'Registro eliminado exitosamente'}];
            }else{
              this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
            }
            this.blockedDocument = false;
          }).catch(err =>{
            console.log(err);
            this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
            this.blockedDocument = false;
          });
        }
      });
    }

    isUsersSelected(){
      return this.usersSelecteds.length > 0;
    }

    updateDrivingSchedule(){
      this.device.drivingSchedules.forEach(drivingSchedule =>{
        drivingSchedule.startTime = this.datePipe.transform(drivingSchedule.startTimeInput,"HH:mm:ss");
        drivingSchedule.endTime = this.datePipe.transform(drivingSchedule.endTimeInput,"HH:mm:ss")
      });
    }

    showMonitoring(device:any){
      let parameters = {idDevice:device.idDevice,idUser:this.userService.userLoged.idUser,phone:device.phone};
      window.open(window.location.href.replace("device","monitoring?token="+btoa(JSON.stringify(parameters))), "_blank");
    }
  }



// WEBPACK FOOTER //
// ./src/app/device/device.component.ts